var _jsxFileName = "/repo/packages/ippm/src/components/CornerRibbon/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PLAN_TYPES, PACKAGE_IDS } from '../../constants/plans';
import { useAppContext } from '../../utils/appContext';
import './corner-ribbon.scss';
var CornerRibbon = function CornerRibbon(_ref) {
  var packageData = _ref.packageData,
    isRecommended = _ref.isRecommended;
  var _useAppContext = useAppContext(),
    getString = _useAppContext.getString,
    displayedPlanType = _useAppContext.displayedPlanType;
  var isRecommendedIndividualPackage = displayedPlanType === PLAN_TYPES.INDIVIDUAL && isRecommended;
  var ribbonContent;
  if (isRecommendedIndividualPackage) {
    ribbonContent = getString('for_you');
  }
  if (displayedPlanType === PLAN_TYPES.TEAMS && packageData.id !== PACKAGE_IDS.ENTERPRISE) {
    ribbonContent = packageData.savings_message;
  }
  if (ribbonContent) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('ribbon', {
        'for-you-ribbon': isRecommendedIndividualPackage,
        'ribbon-top-right': !isRecommendedIndividualPackage
      }),
      "data-testid": "corner-ribbon",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("span", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 9
      }
    }, ribbonContent));
  }
  return null;
};
CornerRibbon.defaultProps = {};
CornerRibbon.propTypes = {
  packageData: PropTypes.shape({
    savings_message: PropTypes.string,
    id: PropTypes.number.isRequired
  }).isRequired,
  isRecommended: PropTypes.bool.isRequired
};
export default CornerRibbon;